import { useMemo, useState } from "react";
import { Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { Grid } from "styled-system/jsx";
import { useBookerContext, useCartContext } from "widgets/booker/contexts";
import { getCartVariantQuantities } from "../Steps/components/MerchVariantSelection";
import { MerchProductCard } from "./MerchProductCard";
import { MerchProductOverlay } from "./MerchProductOverlay";
import { CATALOG_WIDE_MIN_WIDTH } from "./catalogPaneStyles";

export const MerchCatalog = () => {
  const { products } = useBookerContext();
  const { cart } = useCartContext();
  const { t } = useTranslation("booker", { keyPrefix: "MERCH_CATALOG" });
  const isWide = useMediaQuery({ minWidth: CATALOG_WIDE_MIN_WIDTH });

  const [selectedProductId, setSelectedProductId] = useState<string | null>(
    null,
  );
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [initialValueId, setInitialValueId] = useState<string | null>(null);

  const cartVariantQuantities = useMemo(
    () => getCartVariantQuantities(cart),
    [cart],
  );

  // Kept after close so the overlay can finish its exit animation.
  const selectedProduct =
    products.find(p => p._id === selectedProductId) ?? null;

  if (products.length === 0) {
    return <Text color="text.mid">{t("EMPTY")}</Text>;
  }

  return (
    <>
      <Grid
        gridTemplateColumns={isWide ? "repeat(3, minmax(0, 1fr))" : "repeat(2, minmax(0, 1fr))"}
        columnGap="300"
        rowGap="500"
        w="full"
      >
        {products.map(product => (
          <MerchProductCard
            key={product._id}
            product={product}
            cartVariantQuantities={cartVariantQuantities}
            onSelect={(id, valueId) => {
              setSelectedProductId(id);
              setInitialValueId(valueId);
              setOverlayOpen(true);
            }}
          />
        ))}
      </Grid>
      <MerchProductOverlay
        product={selectedProduct}
        open={overlayOpen}
        initialValueId={initialValueId}
        onClose={() => setOverlayOpen(false)}
        cartVariantQuantities={cartVariantQuantities}
      />
    </>
  );
};
